<template>
  <b-modal
    :id="modalId"
    ref="toastModal"
    hide-header
    hide-footer
    :hide-header-close="false"
    :no-close-on-backdrop="false"
    :no-close-on-esc="false"
    centered
    size="md"
    content-class="copy-result-toast-modal"
    @hidden="$emit('closed')"
  >
    <div class="toast-content">
      <div v-if="isError" class="toast-icon-wrapper">
        <b-icon icon="x-circle" class="toast-icon-x-circle" />
      </div>
      <div v-else-if="isWarning" class="toast-icon-circle-warning">
        <b-icon icon="exclamation-lg" class="toast-icon-exclamation" />
      </div>
      <div v-else class="toast-icon-circle-success">
        <b-icon icon="check2" class="toast-icon-check2" />
      </div>

      <div class="toast-title">{{ title }}</div>

      <div class="toast-message">{{ message }}</div>

      <b-button variant="primary" class="toast-ok-btn" @click="close">
        {{ $t('ok') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CopyResultToastModal',

  props: {
    type: {
      type: String,
      default: 'success',
      validator: (v) => ['success', 'error', 'warning'].includes(v)
    }
  },

  data() {
    return {
      modalId: 'copy-result-toast-modal',
      currentType: 'success'
    }
  },

  computed: {
    isError() {
      return this.currentType === 'error'
    },

    isWarning() {
      return this.currentType === 'warning'
    },

    title() {
      if (this.isError) return this.$t('importante')
      if (this.isWarning) return this.$t('copiaconcluidacompendencias')
      return this.$t('copiaconcluidasucesso')
    },

    message() {
      if (this.isError) return this.$t('copysummaryerrorstatus')
      if (this.isWarning) return this.$t('ummodulofoiprocessadocomsucessomasoutroapresentoufalha')
      return this.$t('cliquenobotaookparavisualizaroresumocopia')
    }
  },

  methods: {
    show(type = 'success') {
      this.currentType = ['error', 'warning', 'success'].includes(type) ? type : 'success'
      this.$nextTick(() => {
        this.$refs.toastModal.show()
      })
    },

    close() {
      this.$refs.toastModal.hide()
    }
  }
}
</script>

<style scoped>
.toast-content {
  text-align: center;
  padding: 8px 4px 16px;
}

.toast-icon-wrapper {
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-icon-x-circle {
  color: #E67774;
  font-size: 5rem;
}

.toast-icon-circle-warning {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  border: 5px solid #f5d0a0;
  background-color: #fff;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-icon-exclamation {
  color: #fcc754;
  font-size: 5rem;
  font-weight: bold;
}

.toast-icon-circle-success {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  border: 5px solid #E3F5DA;
  background-color: #fff;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-icon-check2 {
  color: #A1DB83;
  font-size: 5.5rem;
  font-weight: bold;
}

.toast-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #111;
  margin-bottom: 8px;
}

.toast-message {
  color: #222;
  font-size: 0.95rem;
  margin-bottom: 16px;
  line-height: 1.4;
}
</style>

<style>
#copy-result-toast-modal .modal-dialog {
  width: 420px;
  max-width: 420px;
  z-index: 1060;
}

.copy-result-toast-modal.modal-content {
  border-radius: 8px;
}
</style>
